import { CallIcon } from 'foundations-assets/icons/components/CallIcon';
import { EmailIcon } from 'foundations-assets/icons/components/EmailIcon';
import { FoldedPaperIcon } from 'foundations-assets/icons/components/FoldedPaperIcon';
import { MeetingsIcon } from 'foundations-assets/icons/components/MeetingsIcon';
import { TasksIcon } from 'foundations-assets/icons/components/TasksIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { useCallback, useMemo } from 'react';
import { parseTextIfMarkers } from './parseTextWithMarkers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const getActivityIconComponent = activityType => {
  switch (activityType) {
    case 'CALL':
      return CallIcon;
    case 'EMAIL':
      return EmailIcon;
    case 'MEETING':
      return MeetingsIcon;
    case 'NOTE':
      return FoldedPaperIcon;
    case 'TASK':
      return TasksIcon;
    default:
      return null;
  }
};
const getActivityUrl = (activity, message) => {
  var _matchingChip$urls$fi, _matchingChip$urls;
  const {
    activityRecord
  } = activity;
  if (activityRecord === undefined || !(message !== null && message !== void 0 && message.crmRecordChips)) {
    return null;
  }
  const matchingChip = message.crmRecordChips.find(chip => chip.objectTypeId === activityRecord.objectTypeId && chip.objectId === activityRecord.objectId);
  return (_matchingChip$urls$fi = matchingChip === null || matchingChip === void 0 || (_matchingChip$urls = matchingChip.urls) === null || _matchingChip$urls === void 0 || (_matchingChip$urls = _matchingChip$urls.find(url => url.clientSurface === 'EMBEDDED')) === null || _matchingChip$urls === void 0 ? void 0 : _matchingChip$urls.url) !== null && _matchingChip$urls$fi !== void 0 ? _matchingChip$urls$fi : null;
};
const ActivityLink = ({
  activity,
  children,
  message,
  onClick
}) => {
  const activityUrl = getActivityUrl(activity, message);
  return activityUrl ? /*#__PURE__*/_jsx(Link, {
    "data-skip-nav-link-tracking": true,
    href: activityUrl,
    target: "_top",
    rel: "noopener noreferrer",
    onClick: onClick,
    children: children
  }) : children;
};
const ActivityRow = ({
  activity,
  message,
  callbacks,
  sectionId,
  iconWrapper
}) => {
  const {
    date,
    activityType,
    description
  } = activity;
  const ActivityIconComponent = getActivityIconComponent(activityType);
  const parsedDescription = useMemo(() => parseTextIfMarkers(description, message, callbacks, sectionId), [description, message, callbacks, sectionId]);
  const handleActivityClick = useCallback(() => {
    var _callbacks$COMPOSABLE, _callbacks$COMPOSABLE2;
    callbacks === null || callbacks === void 0 || (_callbacks$COMPOSABLE = callbacks.COMPOSABLE_CARD) === null || _callbacks$COMPOSABLE === void 0 || (_callbacks$COMPOSABLE2 = _callbacks$COMPOSABLE.onActivityClick) === null || _callbacks$COMPOSABLE2 === void 0 || _callbacks$COMPOSABLE2.call(_callbacks$COMPOSABLE, typeof activityType === 'string' ? activityType : 'unknown');
  }, [callbacks, activityType]);
  const icon = ActivityIconComponent ? /*#__PURE__*/_jsx(IconHolder, {
    icon: ActivityIconComponent,
    compact: true
  }) : null;
  return /*#__PURE__*/_jsxs(Flex, {
    gap: "300",
    alignItems: "center",
    children: [iconWrapper ? iconWrapper(icon) : icon, /*#__PURE__*/_jsxs(View, {
      children: [/*#__PURE__*/_jsxs(Text, {
        as: "div",
        marginBlockEnd: "100",
        children: [/*#__PURE__*/_jsx(ActivityLink, {
          activity: activity,
          message: message,
          onClick: handleActivityClick,
          children: activity.title
        }), ", ", parsedDescription]
      }), date && /*#__PURE__*/_jsx(Text, {
        typography: "detail-100",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedDateTime, {
          value: new Date(date),
          format: "LLL",
          type: "userTz"
        })
      })]
    })]
  });
};
export default ActivityRow;